import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

interface salesMonthData {
  EXACT_DATE:string;
  Gross_Units:number;
  Gross_Dollars:number;
  Net_Units:number;
  Net_Dollars:number;
  Returns_Units:number;
  Returns_Dollars:number;
  Non_Bill_Units:number;
  Non_Bill_Dollars:number;
}

interface SalesMonthInterface {
  month:string;
  data:salesMonthData[];
}

interface saleDataTypes {
  year:string;
  months:SalesMonthInterface[];
}

interface TitleListState {
  data: saleDataTypes[];
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
  salesMonths: string[];
  oldSalesMonths: string[];
}
const initialState: TitleListState = {
  data: [],
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
  salesMonths: [],
  oldSalesMonths : []
};

export const FetchTitleListSalesRecord = createAsyncThunk(
  "FetchTitleListSalesRecord",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.TITLESALESDATA,data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

const TitleListSlice = createSlice({
  name: "TitleListData",
  initialState,
  reducers: {
    emptyTitleListSalesRecord:(state) => {
      state.data = initialState.data;
      state.error = initialState.error;
      state.isLoading = initialState.isLoading;
      state.status = initialState.status;
      state.statusCode = initialState.statusCode;
      state.salesMonths = initialState.salesMonths
    },
    updateMonthsByYear:(state, action) => {
      const newMonths:string[] = [];
      if(action.payload?.length){
        state.data.map(sale => {
          if (sale.year === action.payload){
            sale.months.map(saleMonth => {
              newMonths.push(saleMonth.month)
            })
          }
        })
        state.salesMonths = newMonths;
      }
      else state.salesMonths = state.oldSalesMonths;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(FetchTitleListSalesRecord.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchTitleListSalesRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data.groupedData
        state.salesMonths = action.payload.data.SalesMonths
        state.oldSalesMonths = action.payload.data.SalesMonths
      })
      .addCase(FetchTitleListSalesRecord.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});

export const {
  emptyTitleListSalesRecord,
  updateMonthsByYear
} = TitleListSlice.actions;
export default TitleListSlice.reducer;
